import { Context, Config } from '@leverege/plugin'
import ModelUtil from '@leverege/model-util'
import I18N from '@leverege/i18n'

const { t, tf, exists } = I18N.ns( 'condition.PropertyCondition' )

const TYPE = 'condition.Property'

const COMPARATORS = [
  { value : '===', name : t( 'eq', 'is' ), shortName : t( 'eqAbbr', '=' ) },
  { value : '!==', name : t( 'neq', 'is not' ), shortName : t( 'neqAbbr', '≠' ) },
  { value : '<', name : t( 'lt', 'Less Than' ), shortName : t( 'ltAbbr', '<' ) },
  { value : '>', name : t( 'gt', 'Greater Than' ), shortName : t( 'gtAbbr', '>' ) },
  { value : '<=', name : t( 'lte', 'Less than or Equal To' ), shortName : t( 'lteAbbr', '<=' ) },
  { value : '>=', name : t( 'gte', 'Greater than or Equal To' ), shortName : t( 'gteAbbr', '>=' ) },
  { value : '[]', name : t( '[]', 'Between (inclusive)' ), shortName : t( '[]Abbr', 'Between (inclusive)' ) },
  { value : '[)', name : t( '[)', 'Between (inclusive of lesser)' ), shortName : t( '[)Abbr', 'Between (inclusive of lesser)' ) },
  { value : '(]', name : t( '(]', 'Between (inclusive of greater)' ), shortName : t( '(]Abbr', 'Between (inclusive of greater)' ) },
  { value : '()', name : t( '()', 'Between (exclusive)' ), shortName : t( '()Abbr', 'Between (exclusive)' ) },
  { value : 'contains', name : t( 'contains', 'Contains' ), shortName : t( 'containsAbbr', 'Contains' ) },
  { value : 'startsWith', name : t( 'startsWith', 'Starts With' ), shortName : t( 'startsWithAbbr', 'Starts With' ) },
  { value : 'endsWith', name : t( 'endsWith', 'Ends With' ), shortName : t( 'endsWithAbbr', 'Ends With' ) },
  { value : 'exists', name : t( 'exists', 'Exists' ), shortName : t( 'existsAbbr', 'Exists' ) },
  { value : 'doesNotExist', name : t( 'doesNotExist', 'Does not Exist' ), shortName : t( 'doesNotExistAbbr', 'Does not Exist' ) }
]

function create( options ) {
  const opts = options || {}
  return {
    type : TYPE,
    path : opts.path || null,
    coerceValue : opts.coerceValue || false,
    contextPath : opts.contextPath === undefined ? Context.TARGET : opts.contextPath,
    comparator : opts.comparator || '===',
    value1 : opts.value1 || null,
    value2 : opts.value2 || null
  }
}

export default { 
  TYPE,
  create,
  name : tf( 'name', 'Property Condition' ),
  layout : () => { return Config.get( 'PropertyCondition', 'layout', { sort : 'Property' } ) },
  help : () => { return exists( 'help' ) ? t( 'help' ) : null },
  handles : () => true, 
  ...ModelUtil.createAllValue( 'path' ),
  ...ModelUtil.createAllValue( 'contextPath' ),
  ...ModelUtil.createAllValue( 'comparator' ),
  ...ModelUtil.createAllValue( 'value1' ),
  ...ModelUtil.createAllValue( 'value2' ),
  ...ModelUtil.createAllValue( 'coerceValue' ),

  isNumberComparator( value ) {
    const v = typeof value === 'string' ? value : value.comparator
    return !( v === '===' || v === '!==' || v === 'startsWith' || v === 'endsWith' || v === 'contains' )
  },

  isValue2Used( value ) {
    return (
      value.comparator === '()' || 
      value.comparator === '(]' ||
      value.comparator === '[)' ||
      value.comparator === '[]' )
  },

  COMPARATORS
}
